
function randomSubstring() {
  return Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
}

/**
 * Creates a ramdom id with the current timestamp
 * @returns {String} Random Id
 */
export default function randomId() {
  return randomSubstring() + Date.now() + randomSubstring();
}
